import React, { useContext } from "react";

import { useAccordionToggle, AccordionContext } from 'react-bootstrap'

function ArrowAccordion({ children, eventKey, active, setActive, callback, editorOptions, adminsidebar }) {
	const currentEventKey = useContext(AccordionContext);

	const decoratedOnClick = useAccordionToggle(
		eventKey,
		() => callback && callback(eventKey),
	);

	const isCurrentEventKey = currentEventKey === eventKey;
	return (
		<button
			type="button"
			className="btn btn-primary"
			onClick={() => {
				decoratedOnClick()
				if (active == eventKey) {
					setActive("")
				} else {
					setActive(eventKey)
				}
			}}
		>
			{isCurrentEventKey ?
				(
					<img
						src={editorOptions ? "/images/down-arrow.svg" : adminsidebar ? "/images/admindrop.svg" : "/images/acc-dropdown.svg"}
						style={{
							"-webkit-transition": "-webkit-transform 0.3s ease-in"
						}}
					/>
				) : (
					<img
						src={editorOptions ? "/images/down-arrow.svg" : adminsidebar ? "/images/admindrop.svg" : "/images/acc-dropdown.svg"}
						style={{
							transform: "rotate(-90deg)",
							"-webkit-transition": "-webkit-transform 0.3s ease-in"
						}}
					/>
				)}
		</button>
	);
}

export default ArrowAccordion;
